import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { isNil, isEmpty } from "ramda";
import { Typography } from "@mui/material";

import MakeMessagePresenter from "presenters/MakeMessagePresenter";

import useStyles from "./useStyles";

const MakeMessage = (props) => {
  const { onModalOpen, makeMessage, isOwner } = props;
  const classes = useStyles();

  const recipient = MakeMessagePresenter.recipient(makeMessage);
  const message = MakeMessagePresenter.message(makeMessage);
  const sender = MakeMessagePresenter.sender(makeMessage);

  if (isEmpty(MakeMessagePresenter.message(makeMessage)) || isNil(MakeMessagePresenter.message(makeMessage))) {
    return null;
  }

  const renderText = () => (
    <>
      {recipient && <Typography variant="large">{`${recipient},`}</Typography>}
      <Typography variant="x-large" className={classes.messageText}>
        {message}
      </Typography>
      {sender && <Typography variant="large">{`From, ${sender}`}</Typography>}
    </>
  );

  if (isOwner) {
    return (
      <button
        type="button"
        data-testid="makeMessage-textButton"
        className={clsx(classes.message, { [classes.messageOwner]: isOwner })}
        onClick={onModalOpen}
      >
        {renderText()}
      </button>
    );
  }

  return <div className={classes.message}>{renderText()}</div>;
};

MakeMessage.propTypes = {
  makeMessage: MakeMessagePresenter.shape().isRequired,
  isOwner: PropTypes.bool.isRequired,
  onModalOpen: PropTypes.func.isRequired,
};

export default MakeMessage;
